const emptyText = "-";

export const hasProfileValue = value=>{
    if (value == null) { return false; }
    return String(value).trim() !== "";
};

export const toProfileText = value=>{
    if (!hasProfileValue(value)) { return emptyText; }
    return String(value);
};

export const formatProfileDate = value=>{
    if (!hasProfileValue(value)) { return emptyText; }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) { return emptyText; }

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}. ${month}. ${year}`;
};

export const formatProfileAddress = (profile={})=>{
    const street = [profile.street, profile.house].filter(hasProfileValue).join(" ");
    const city = [profile.zip, profile.city].filter(hasProfileValue).join(" ");
    const parts = [street, city].filter(hasProfileValue);

    return parts.join(", ") || emptyText;
};

export const formatProfileCredit = value=>{
    if (!hasProfileValue(value)) { return emptyText; }

    const amount = Number(value);
    if (!Number.isFinite(amount)) { return emptyText; }

    return new Intl.NumberFormat("cs-CZ").format(amount);
};

const avConsentFields = Object.freeze(["acceptedAVA", "acceptedAVB", "acceptedAVC"]);

export const getAvConsent = (profile={})=>{
    const dates = avConsentFields
        .map(field=>formatProfileDate(profile[field]))
        .filter(date=>date !== emptyText);

    return {
        count:dates.length,
        dates:dates.join(", ") || emptyText
    };
};
